// extracted by mini-css-extract-plugin
export default {"metadatas":"Metadatas-metadatas-a1EOe"};